import { createApp } from "vue";
import { createPinia } from "pinia";
import Vant from "vant";
import "vant/lib/index.css";
import "./styles/tokens.css";
import App from "./App.vue";
import router from "./router";
import { loadAppConfig, applyThemeColors } from "./composables/useAppConfig";
import { resolveActiveEventOnBoot, resolveDeepLinkEventOnBoot, resolveColdEntryOnBoot } from "./composables/useActiveEvent";

// Dev-only preview login: open the app with `?__devjwt=<token>` to seed the
// auth JWT and view logged-in pages outside the LINE app. The param is
// stripped immediately and this whole block is dropped from production
// builds (import.meta.env.DEV is false there) — never a prod backdoor.
if (import.meta.env.DEV) {
  const params = new URLSearchParams(location.search);
  const devJwt = params.get("__devjwt");
  if (devJwt) {
    localStorage.setItem("jwt", devJwt);
    params.delete("__devjwt");
    const qs = params.toString();
    location.replace(location.pathname + (qs ? `?${qs}` : ""));
  }
}

// Resolve which activity this LIFF session is in BEFORE any per-event fetch:
// if entered via a store QR (/checkin/:barId), bind to that store's event and
// persist it (last-scanned); otherwise keep the localStorage value (empty →
// backend featured). MUST run before loadAppConfig so the first config calls
// send the correct ?event=. `.finally` so a resolve failure never blocks boot.
// Then fetch per-deployment brand config BEFORE mount so liff.init / maps /
// brand name have their runtime values ready.
//
// A `?event=<slug>` deep link binds THIS TAB first (sessionStorage, wins over
// the shared localStorage) — powers multi-event preview tabs in dev and
// per-activity share links in prod. A store-QR /checkin still resolves below.
resolveDeepLinkEventOnBoot();
resolveActiveEventOnBoot().finally(() => {
  resolveColdEntryOnBoot().finally(() => {
    loadAppConfig().finally(() => {
      applyThemeColors();           // path A: inject CSS vars before first render
      const app = createApp(App);
      app.use(createPinia());
      app.use(router);
      app.use(Vant);
      app.mount("#app");
    });
  });
});
